<template>
	<div>
		<div
			v-if="userProfile.role !== 'person' && person && person.temporalOTs.length"
			class="text-left pa-2"
			style="border: 1px solid gray; border-radius: 10px;"
		>
			<div v-for="(tempOT, i) in person.temporalOTs" :key="i" class="mb-2">
				<div class="d-flex align-center mb-1">
					<div class="mr-1">
						<span>
							OT Temporal creada el: <b>{{ tempOT.date }}</b>
						</span>
					</div>
					<v-btn
						x-small
						color="success"
						rounded
						@click="asignarOTaActividad(lodgingSelect._id, tempOT)"
					>
						Asignar a esta actividad
						<v-icon right>mdi-plus</v-icon>
					</v-btn>
					<v-btn
						x-small
						color="error"
						rounded
						class="ml-1"
						@click="
							eliminarTemporalOT({
								idPlace: selectedPlace._id,
								idot: tempOT._id,
							})
						"
					>
						Eliminar
						<v-icon right>mdi-delete</v-icon>
					</v-btn>
				</div>
				<div>
					<div class=" pa-2" style="background-color: #d3ebff; border-radius: 10px">
						<div>
							<h5>Resumen de datos ingresados</h5>
						</div>

						<span v-for="(item, i) in tempOT.infoOT" :key="i">
							<span style="font-size: 12px !important">{{
								verifyData(tempOT.infoOT[0])
							}}</span>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	props: {
		lodgingSelect: {
			required: true,
		},
		selectedPlace: {
			required: true,
		},
		person: {
			required: true,
		},
	},
	methods: {
		async asignarOTaActividad(idLod, tempOT) {
			const data = JSON.stringify(tempOT.infoOT[0]);
			const payload = new FormData();
			payload.append('order', data);
			await this.createWorkOrder({
				idLodging: idLod,
				payload,
			});
			await this.eliminarTemporalOT({
				idPlace: this.selectedPlace._id,
				idot: tempOT._id,
			});
		},
		verifyData(item) {
			let text = '';
			text = 'Fecha: ' + item.date + '...';
			if (item.data)
				item.data.forEach(i => {
					if (
						!Array.isArray(i) &&
						typeof i != 'object' &&
						i != null &&
						i != '' &&
						i != ' ' &&
						i != undefined &&
						typeof i != 'boolean'
					) {
						text = text + '...' + i;
					}
				});
			return text;
		},
		...mapActions({
			eliminarTemporalOT: 'Place/eliminarTemporalOT',
			createWorkOrder: 'Lodging/createWorkOrder',
		}),
	},
};
</script>
